<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppLayout',
})
</script>
<template>
	<CommonLayout :favorite="favorite" />
</template>
<script lang="ts" setup name="AppLayout">
import CommonLayout from 'packages/layout/index.vue'
import type { LayoutFavoriteApi } from 'packages/layout/types'

const favorite: LayoutFavoriteApi = {
	create: clientFavoriteNavigationCreate,
	delete: clientFavoriteNavigationDelete,
	sort: clientFavoriteNavigationSort,
	list: clientFavoriteNavigationList,
}
</script>
